import { render, staticRenderFns } from "./ColourHeader.vue?vue&type=template&id=1d5e6340&"
import script from "./ColourHeader.vue?vue&type=script&lang=js&"
export * from "./ColourHeader.vue?vue&type=script&lang=js&"
import style0 from "./ColourHeader.vue?vue&type=style&index=0&id=1d5e6340&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIReviewsAlt: require('/opt/build/repo/components/UI/ReviewsAlt.vue').default,CardsAccreditation: require('/opt/build/repo/components/Cards/Accreditation.vue').default,UIBreadcrumb: require('/opt/build/repo/components/UI/Breadcrumb.vue').default})
